import { render, staticRenderFns } from "./CreateCustomerCreditNotePopUp.vue?vue&type=template&id=01afc3e8&scoped=true&"
import script from "./CreateCustomerCreditNotePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerCreditNotePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerCreditNotePopUp.vue?vue&type=style&index=0&id=01afc3e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afc3e8",
  null
  
)

export default component.exports